type RequiredViewProps<T> = {
  [K in keyof T as undefined extends T[K] ? never : K]: T[K];
};

type OptionalViewProps<T> = {
  [K in keyof T as undefined extends T[K] ? (T[K] extends undefined ? never : K) : never]?:
    Exclude<T[K], undefined>;
};

export type DefinedViewProps<T> = RequiredViewProps<T> & OptionalViewProps<T>;

export type ViewPropsInput<T> = {
  [K in keyof T]?: T[K] | undefined;
};

/** Strip undefined values for exactOptionalPropertyTypes when wiring pages → views. */
export function viewProps<T extends object>(props: T): DefinedViewProps<T> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(props)) {
    if (value !== undefined) out[key] = value;
  }
  return out as DefinedViewProps<T>;
}
